import React, { lazy, Suspense } from 'react'
import { Spin } from 'antd'

// Lazy load components to prevent unnecessary initialization
const ModernMemberManagement = lazy(() => import('./AllMemberManagement/ModernMemberManagement'))
const GroupFeeManagement = lazy(() => import('./GroupFeeManagement'))
const ReferralManagement = lazy(() => import('./ReferralManagement'))
const UserList = lazy(() => import('./UserList'))
const VAccount = lazy(() => import('./Vaccount'))

interface RenderComponentProps {
  type: string
  props?: any
}

const RenderComponent: React.FC<RenderComponentProps> = React.memo(({ type, props }) => {
  const renderComponent = () => {
    switch (type) {
      case 'ModernMemberManagement':
        return <ModernMemberManagement {...props} />
      case 'GroupFeeManagement':
        return <GroupFeeManagement />
      case 'ReferralManagement':
        return <ReferralManagement />
      case 'VAccount':
        return <VAccount />
      case 'UserList':
        return <UserList />
      default:
        return null
    }
  }

  return (
    <Suspense fallback={<Spin size="large" style={{ display: 'block', margin: '50px auto' }} />}>
      {renderComponent()}
    </Suspense>
  )
})

export default RenderComponent